export default __webpack_public_path__ + "static/media/manual.6be99e60.svg";